// extracted by mini-css-extract-plugin
export default {"link":"WhatsApp_link__VkPXi"};